import { render, staticRenderFns } from "./CoreFeaturesSection.vue?vue&type=template&id=0622c80e&scoped=true"
import script from "./CoreFeaturesSection.vue?vue&type=script&lang=js"
export * from "./CoreFeaturesSection.vue?vue&type=script&lang=js"
import style0 from "./CoreFeaturesSection.vue?vue&type=style&index=0&id=0622c80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622c80e",
  null
  
)

export default component.exports